/* eslint-disable */

import { Outlet, useLocation } from 'react-router-dom'
import Footer from '../Components/Footer'
import BottomNavbar from '../Components/BottomNavbar'
import Header from '../Components/Header'
import Navbar from '../Components/Navbar'
import MFTopNavbar from './MutualFunds/MFTopNavbar'

const PostLoginContainer = () => {
  const location = useLocation()
  const pathname = location.pathname
  const isMFPage = pathname.includes('mutual-funds')

  const hideBottomNavbar =
    pathname.includes('tax-filing') ||
    pathname.includes('firstTime') ||
    pathname.includes('place-order') ||
    pathname.includes('order-payment') ||
    pathname.includes('payment-request') ||
    pathname.includes('one-time-payment') ||
    pathname.includes('actionplan/mandate') ||
    pathname.includes('/dashboard/holdings') ||
    pathname.includes('/dashboard/start-kyc') ||
    pathname.includes('mutual-funds/mandate')

  const hideTopNav =
    pathname.includes('mutual-funds') ||
    pathname.includes('firstTime/questionnaire') ||
    pathname.includes('/dashboard/start-kyc') ||
    pathname.includes('one-time-payment/status') ||
    pathname.includes('redeem') ||
    pathname.includes('refer') ||
    pathname.includes('profile') ||
    pathname.includes('portfolio-allocation') ||
    pathname.includes('family-dashboard')

  const hideNavbar =
    !pathname.includes('one-time-payment/status') && !pathname.includes('firstTime/questionnaire')

  return (
    <>
      <div className='lg:hidden'>
        {location.pathname !== '/dashboard/mutual-funds' &&
          location.pathname !== '/dashboard' &&
          location.pathname !== '/dashboard/mutual-funds/details' &&
          !pathname.includes('tax-filing') &&
          !pathname.includes('insurance') &&
          !pathname.includes('firstTime') &&
          !pathname.includes('returns') &&
          !pathname.includes('support') &&
          !pathname.includes('actionplan/one-time-payment') && <MFTopNavbar />}
      </div>

      {hideTopNav ? null : <Header />}

      {hideNavbar && <Navbar />}

      <div
        className={`flex justify-center pb-28 lg:pb-16 ${
          pathname.includes('/firstTime/questionnaire') ? 'fabits-questionnaire-layout' : ''
        } ${pathname === '/dashboard' ? 'fabits-page-shell' : ''}`}
      >
        <div
          className={`w-full ${
            !pathname.includes('/tax-filing') &&
            !pathname.includes('one-time-payment/status') &&
            !pathname.includes('firstTime/questionnaire') &&
            'lg:mt-[52px]'
          } ${
            isMFPage ||
            pathname.includes('/tax-filing') ||
            pathname.includes('firstTime') ||
            pathname.includes('one-time-payment/status')
              ? 'max-w-auto mb-0'
              : 'max-w-[1128px] mb-16 lg:pb-12 lg:pt-4'
          }`}
        >
          <Outlet />
          {!hideBottomNavbar && <BottomNavbar />}
          <Footer />
        </div>
      </div>
    </>
  )
}

export default PostLoginContainer
